import type { FeatureFlags } from '@shared/services/feature-flag/feature-flags';

export class UITab {
  constructor(public text: string, public link: string, public featureFlag?: FeatureFlags) {}
}
